import {Circle, Print, PrintDisabled} from "@mui/icons-material";
import {Pattern} from "./Pattern";
import {IconButton, Tooltip} from "@mui/material";
import React from "react";
import {color_transparent} from "../App";

export const PrintView = ({state, setState}) => {
    let colorElements = [];
    state.colors.filter((c) => c.id !== 0).forEach((c) => {
        colorElements.push(
            <div key={c.id} className="color">
                <Circle style={{color: c.color}}/>
                <span className="color-name">{c.name}</span>
            </div>
        );
    });

    return (
        <div className="print">
            <Pattern
                increase={state.increase}
                size={state.size}
                height={state.height}
                repeats={state.repeats}
                left={state.left}
                tiles={state.tiles}
                onTileClick={() => {
                }}
                colors={state.colors.concat(color_transparent)}
                editable={false}
            />
            <div className="print-colors">{colorElements}</div>
            <div className="print-view-buttons">
                <Tooltip title="Drucken" arrow>
                    <IconButton onClick={() => window.print()}>
                        <Print/>
                    </IconButton>
                </Tooltip>
                <Tooltip title="Druckansicht schließen" arrow>
                    <IconButton onClick={() => setState({...state, print: false})}>
                        <PrintDisabled/>
                    </IconButton>
                </Tooltip>
            </div>
        </div>
    );
};